// Dedicated DB: logout/cache cleanup must never delete unacknowledged intents.
const DB = 'MSalesNotificationsV1';
let database;
export const emptyState = () => ({ version: 1, rows: {}, operations: {}, lastSync: null, historyChecked: null, generation: 0 });
const open = () => {
  if (!database) database = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB, 1);
    request.onupgradeneeded = () => request.result.createObjectStore('scopes');
    request.onsuccess = () => { request.result.onversionchange = () => { request.result.close(); database = null; }; resolve(request.result); };
    request.onerror = () => { database = null; reject(request.error); };
    request.onblocked = () => { database = null; reject(new Error('Lokalna baza je zauzeta')); };
  });
  return database;
};

// All changes to rows, intents and the published generation commit together.
// The synchronous callback always receives the latest state inside the transaction.
export async function transact(scope, change) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('scopes', change ? 'readwrite' : 'readonly');
    const store = tx.objectStore('scopes');
    const request = store.get(scope);
    let state;
    let failure;
    request.onsuccess = () => {
      try {
        state = request.result || emptyState();
        if (change) { change(state); store.put(state, scope); }
      } catch (error) { failure = error; tx.abort(); }
    };
    tx.oncomplete = () => resolve(state);
    tx.onerror = () => reject(failure || tx.error || new Error('Lokalni upis nije uspio'));
    tx.onabort = () => reject(failure || tx.error || new Error('Lokalni upis nije uspio'));
  });
}

export const queueClose = (scope, id) => transact(scope, state => {
  if (!state.rows[id] || state.rows[id].completedAt || state.completed?.[id] || state.operations[id]) return;
  state.operations[id] = {
    type: 'COMPLETE_NOTIFICATION', operationId: `${id}-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    notificationId: id, ownerScope: scope, createdAtLocal: new Date().toISOString(), attemptCount: 0, lastError: null,
  };
});
export function applyStates(state, results) {
  results.forEach(result => {
    if (result.status === 'UNAVAILABLE') {
      state.unavailable = state.unavailable || {};
      state.unavailable[result.id] = true;
      if (state.completed) delete state.completed[result.id];
      delete state.rows[result.id]; delete state.operations[result.id];
    } else if (result.status === 'COMPLETED') {
      if (state.unavailable?.[result.id]) return;
      state.completed = state.completed || {};
      state.completed[result.id] = result.notification.completedAt;
      state.rows[result.id] = result.notification; delete state.operations[result.id];
    } else if (!state.unavailable?.[result.id] && !state.completed?.[result.id] && !state.rows[result.id]?.completedAt) state.rows[result.id] = result.notification;
  });
}
export function pruneHistory(state) {
  Object.values(state.rows).filter(row => row.completedAt && !state.operations[row.id])
    .sort((a, b) => b.completedAt.localeCompare(a.completedAt) || compareIds(b.id, a.id))
    .slice(500).forEach(row => { delete state.rows[row.id]; });
}
export function compareIds(a, b) {
  return String(a).length - String(b).length || String(a).localeCompare(String(b));
}
export function mergeSnapshot(state, nodes, results, startedGeneration) {
  // Reconcile only known absences. A new close/ack during the fetch wins.
  const resultsById = new Map(results.map(r => [r.id, r]));
  nodes.forEach(row => { if (!state.unavailable?.[row.id] && !state.completed?.[row.id] && !state.rows[row.id]?.completedAt) state.rows[row.id] = row; });
  resultsById.forEach(result => {
    if (result.status === 'UNAVAILABLE' || result.status === 'COMPLETED') applyStates(state, [result]);
    else if (!state.unavailable?.[result.id] && !state.completed?.[result.id] && !state.rows[result.id]?.completedAt) state.rows[result.id] = result.notification;
  });
  state.generation = Math.max(state.generation, startedGeneration) + 1;
  state.lastSync = new Date().toISOString();
  pruneHistory(state);
}
